import { render, staticRenderFns } from "./CreateLeave.vue?vue&type=template&id=f0b15226&scoped=true&%3AroutePreventDialog=routePreventDialog&%3AcustomClass='leave-update'"
import script from "./CreateLeave.vue?vue&type=script&lang=js"
export * from "./CreateLeave.vue?vue&type=script&lang=js"
import style0 from "./CreateLeave.vue?vue&type=style&index=0&id=f0b15226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b15226",
  null
  
)

export default component.exports